export default null
declare let self: ServiceWorkerGlobalScope

// TODO andre. evict outdated assets

const STATIC_CACHE = 'static'
const SETTINGS_CACHE = 'settings'
const currentCaches = [STATIC_CACHE, SETTINGS_CACHE]

self.addEventListener('install', (event) => {
    void self.skipWaiting()
})

self.addEventListener('activate', (event) => {
    event.waitUntil((async() => {
        const cacheNames = await caches.keys()
        const cachesToDelete = cacheNames.filter((cacheName) => !currentCaches.includes(cacheName))
        await Promise.all(cachesToDelete.map((cacheToDelete) => caches.delete(cacheToDelete)))
        return self.clients.claim()
    })())
})

const discordDevActivityIds = ['1041609930710466600', '1103704792565555231', '1103922077301485618']
const isDiscordDev = discordDevActivityIds.some((id) => self.registration.scope.includes(id))
self.addEventListener('fetch', (event) => {
    const isMethodGet = event?.request?.method == 'GET'
    if(!isMethodGet) return

    const isExternalDomain = !event.request.url.startsWith(self.registration.scope)
    if(isExternalDomain) return

    const isDevelopment = event.request.url.startsWith('http://') || isDiscordDev
    if(isDevelopment) return

    // for some reason, auth requests on android app are getting intercepted and user is being redirected to web login page.
    // As there is no reason to cache auth requests, we return early here to avoid the issue
    const isAuthedRequest = event.request.url.includes('/auth/')
    if(isAuthedRequest) return

    // for some reason, even when the adblocker is disabled for our page, using fetch(event.request) still gets blocked
    // returning early here lets that browser fetch the file as it normally would without getting blocked
    if(event.request.url.includes('prebid')) return

    event.respondWith((async() => {
        const cachedResponse = await cacheFile(event.request)
        if(cachedResponse) return cachedResponse

        const languageResponse = await loadI18nEntryPage(event.request)
        if(languageResponse) return languageResponse

        return fetch(event.request)
    })())
})

self.addEventListener('message', async(event) => {
    if(event.data.type == 'languageChange') {
        const cache = await caches.open(SETTINGS_CACHE)
        await cache.put('language', new Response(event.data.language))
    }
})

async function cacheFile(request: Request): Promise<Response | undefined> {
    // TODO cache all hashed files in the future?
    const isImage = request.url.includes('/images/') || !!request.url.match(/\.(svg|png|jpg|gif|jpeg)$/)
    const isSound = request.url.includes('/sounds/') || !!request.url.match(/\.mp3$/)
    const shouldCacheFile = isImage || isSound
    if(!shouldCacheFile) return

    const isMobile = request.referrer.includes('/mobile')
    if(!isMobile) return

    const url = new URL(request.url)
    const urlSearchParams = new URLSearchParams(url.search)

    const hasHash = !!urlSearchParams.get('rev')
        || !!urlSearchParams.get('v')
        || !!request.url.match(/\.\w{20}\..{3,4}$/)
    if(!hasHash) return

    const cache = await caches.open(STATIC_CACHE)

    const cachedResponse = await cache.match(request)
    if(cachedResponse != undefined) {
        return cachedResponse
    }

    while(await cache.delete(request, {ignoreSearch: true})) { // delete old version from cache
        // loop exits once no old version is found
    }

    const response = await fetch(request)

    if(response.status >= 300) return response

    await cache.put(request, response.clone())
    return response
}

async function loadI18nEntryPage(request: Request): Promise<Response | undefined> {
    const isWebIndexPage = request.url === self.registration.scope
    const isDiscordIndexPage = request.url.startsWith(`${self.registration.scope}discord/web`)
    const isMobileIndexPage = request.url.startsWith(`${self.registration.scope}mobile`)
    const isIndexPage = isWebIndexPage || isDiscordIndexPage || isMobileIndexPage
    if(!isIndexPage) return

    const language = await Promise.race([getLanguageFromCache(), new Promise<undefined>((resolve) => setTimeout(() => resolve(undefined), 200))])
    if(!language) return
    if(language == 'en') return

    const adjustedLanguageURL = new URL(request.url)
    if(isDiscordIndexPage) {
        adjustedLanguageURL.pathname = adjustedLanguageURL.pathname.replace('/.proxy', `/.proxy/${language}`)
    }
    if(isWebIndexPage) {
        adjustedLanguageURL.pathname = `/${language}`
    }
    if(isMobileIndexPage) {
        adjustedLanguageURL.pathname = `/${language}/mobile`
    }

    const requestWithLanguage = new Request(adjustedLanguageURL, {
        method: request.method,
        headers: request.headers,
        mode: 'same-origin',
        credentials: request.credentials,
        redirect: request.redirect,
    })

    return fetch(requestWithLanguage)
}

async function getLanguageFromCache(): Promise<string | undefined> {
    const cache = await caches.open(SETTINGS_CACHE)
    const languageResponse = await cache.match('language')
    return languageResponse?.text()
}
